<div class="d-flex flex-column align-items-center my-5">
  <h1>Page non trouvée</h1>
  <p>La page que vous recherchez semble introuvable.</p>
  <button class="btn btn-primary" routerLink="/">Retourner à l'accueil</button>
</div>

